import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useScenarioSelectionRedefinedWrapperTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/useScenarioSelectionRedefinedWrapperTemplate';
import { FDStack } from '@facet-wealth/design';
import ScenarioSelectionRedefinedWrapperHeader
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedWrapperHeader';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import ScenarioSelectionRedefinedStepLayoutWithContentHeader
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedStepLayoutWithContentHeader';
import StepNavigator from 'Components/ComponentLibrary/Molecules/StepNavigator';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import useSelectScenarioContext
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import {
  ExecuteSelectLoadingPage,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/ExecuteSelectLoadingPage';
import Box from '../../../../../../../Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = makeStyles(theme => ({
  stepNavigator: {
    position: 'sticky',
    bottom: 0,
  },
  form: {
    flexGrow: 1,
    backgroundColor: theme.palette.facet.lightGray,
  },
}));

const ScenarioSelectionRedefinedWrapperTemplateBody = ({
  resource,
  layout,
  metaOverrideSet,
  showBottomStepNavigators,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {
    handleNext,
    handlePrevious,
    errors,
    loading,
    isPageContentLoading,
  } = useScenarioSelectionRedefinedWrapperTemplate({
    resource,
  });

  const { isSelecting } = useSelectScenarioContext();

  if (resource.isTruthy('shouldExecuteSelect') && isSelecting) {
    return <ExecuteSelectLoadingPage resource={resource} />;
  }

  return (
    <FDStack direction={'column'} height={'100%'} width={'100%'}>
      <ScenarioSelectionRedefinedWrapperHeader resource={resource} />
      {/* Need to use form class instead of wrapping this in FD Paper because MetaFormInline does not respect */}
      {/* change in background color from useBoneBackgroundColor */}
      <MetaFormInline
        className={classes.form}
        noIndividualSubmitButtons
        resource={resource}
        LayoutProps={{
          hideErrorList: true,
          errors,
          layout,
          resource,
        }}
        layout={ScenarioSelectionRedefinedStepLayoutWithContentHeader}
        margin={'none'}
        padding={'none'}
        metaOverrideSet={metaOverrideSet}
      />
      {showBottomStepNavigators ? (
        <Box className={classes.stepNavigator}>
          <StepNavigator
            onNext={handleNext}
            onPrevious={handlePrevious}
            isLoading={isPageContentLoading || loading}
          >
            {resource.attr('primaryActionLabel') || 'Continue'}
          </StepNavigator>
        </Box>
      ) : null}
    </FDStack>
  );
};

ScenarioSelectionRedefinedWrapperTemplateBody.defaultProps = {
  metaOverrideSet: undefined,
  showBottomStepNavigators: true,
};

ScenarioSelectionRedefinedWrapperTemplateBody.propTypes = {
  /** layout: The body content layout * */
  layout: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.node]).isRequired,
  /** metaOverrideSet: A meta override set * */
  metaOverrideSet: PropTypes.object,
  /** resource: The displayed resource * */
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  showBottomStepNavigators: PropTypes.bool,
};

export default ScenarioSelectionRedefinedWrapperTemplateBody;
